module.exports = __webpack_public_path__ + "static/media/arPortal_white.d51cbd90.svg";